<template>
  <div class="costAdjustOrderList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="false"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @dblclickEvent="dblclickEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width || 120"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :type="item.type"
          :params="item.params"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import API from '@/api/wareHouse/costAdjustOrder';
  import DataBaseAPI from '@/api/dataBase';
  import { filterEmpty } from '@/common/js/util';
  // import MASTER_API from '@/api/masterData/company.js';
  import tableMixins from '@/common/mixins/table.js';
  // import qs from 'qs';
  // import siruiUpload from '@/components/SiruiUpload';
  // import loading from '@/common/js/load.js'; //loading
  // import InputNumber from '@/components/form-item/input-number';
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  import XEUtils from 'xe-utils';
  export default {
    name: 'costAdjustOrderList',
    mixins: [tableMixins],
    components: {
      // siruiUpload,
      // InputNumber,
      BatchConfirmDialog,
    },
    data() {
      return {
        query: {
          departmentCode: undefined,
          voucherNo: null,
          accountingStatus: null,
          storageNo: null,
          storageCompanyCode: null,
          productNo: null,
          batchNo: null,
          docNo: null,
          docStatus: null,
          startGmtCreate: null,
          endGmtCreate: null,
        },
        companyList: [], //公司列表
        departmentList: [], //部门列表
        //表格显示字段
        columnListDefault: [
          { type: 'checkbox', visible: true, width: '50', fixed: 'left' },
          { field: 'docNo', title: 'costAdjustOrderList.column.docNo', visible: true, width: 150 }, //单据编号
          {
            field: 'docStatus',
            title: 'costAdjustOrderList.column.docStatus',
            visible: true,
            width: 120,
            dictType: 'cost_adjust_order_status',
          }, //单据状态
          {
            field: 'accountingStatus',
            title: 'costAdjustOrderList.column.accountingStatus',
            visible: true,
            width: 100,
            dictType: 'post_status',
          }, //入账状态
          // 凭证号
          { field: 'voucherNo', title: '凭证号', visible: true, width: 120 },
          {
            field: 'storageCompanyCode',
            title: 'costAdjustOrderList.column.companyCode',
            visible: true,
            width: 120,
          }, //公司编码
          {
            field: 'storageCompanyName',
            title: 'costAdjustOrderList.column.companyName',
            visible: true,
            width: 120,
          }, //公司名称
          {
            field: 'storageDepartmentCode',
            title: 'costAdjustOrderList.column.departmentCode',
            visible: true,
            width: 120,
          }, //部门编码
          {
            field: 'storageDepartmentName',
            title: 'costAdjustOrderList.column.departmentName',
            visible: true,
            width: 120,
          }, //部门名称
          {
            field: 'storageNo',
            title: 'costAdjustOrderList.column.storageDepartmentCode',
            visible: true,
            width: 120,
          }, //仓库编码
          {
            field: 'storageName',
            title: 'costAdjustOrderList.column.storageDepartmentName',
            visible: true,
            width: 120,
          }, //仓库名称
          {
            field: 'productNo',
            title: 'costAdjustOrderList.column.productNo',
            visible: true,
            width: 120,
          }, //物料编码
          {
            field: 'productName',
            title: 'costAdjustOrderList.column.productName',
            visible: true,
            width: 120,
          }, //物料描述
          {
            field: 'productUnit',
            title: 'costAdjustOrderList.column.productUnit',
            visible: true,
            width: 60,
            dictType: 'basic_unit',
          }, //单位
          {
            field: 'gmtCreate',
            title: 'costAdjustOrderList.column.gmtCreate',
            visible: true,
            width: 120,
          }, //调整日期
          {
            field: 'adjustStorageAmount',
            title: 'costAdjustOrderList.column.adjustStorageAmount',
            visible: true,
            width: 150,
            format: 'formatAmountRound',
          }, //业务库存调整金额
          {
            field: 'adjustMainBusinessCost',
            title: 'costAdjustOrderList.column.adjustMainBusinessCost',
            visible: true,
            width: 150,
            format: 'formatAmountRound',
          }, //已发货成本调整金额
          {
            field: 'currencyName',
            title: 'costAdjustOrderList.column.currencyName',
            visible: true,
            width: 80,
          }, //币种
        ],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        dictList: (state) => state.dict.dictList,
        tokenInfo() {
          return {
            access_token: this.userInfo.access_token,
            companyCode: this.userInfo.companyCode,
            companyName: this.userInfo.companyName,
            departmentCode: this.userInfo.departmentCode,
            departmentName: this.userInfo.departmentName,
            tenantCode: this.userInfo.tenantCode,
          };
        },
      }),
      //搜索字段
      searchColumns() {
        return [
          {
            //公司代码
            prop: 'storageCompanyCode',
            name: this.$t('costAdjustOrderList.search.companyName'),
            type: 'select',
            placeholder: this.$t('costAdjustOrderList.placeholder.companyCodePlaceholder'),
            options: this.companyList,
            relatedColumn: 'none',
            changeMethod: 'searchCompanyName',
          },
          {
            //部门
            prop: 'storageDepartmentCode',
            name: this.$t('costAdjustOrderList.search.departmentName'),
            placeholder: this.$t('costAdjustOrderList.placeholder.departmentCodePlaceholder'),
            type: 'select',
            relatedColumn: 'none',
            options: this.departmentList,
          },
          //仓库
          {
            prop: 'storageName',
            type: 'searchTableSpec',
            name: this.$t('costAdjustOrderList.search.storageDepartmentName'),
            clearable: true,
            searchType: 'warehouse',
            isMultiple: true,
          },
          //物料描述
          {
            prop: 'productName',
            name: this.$t('costAdjustOrderList.search.productName'),
            type: 'input',
            clearable: true,
          },
          //业务入库批次号
          {
            prop: 'batchNo',
            name: this.$t('costAdjustOrderList.search.batchNo'),
            type: 'input',
            clearable: true,
          },
          //单据编号
          {
            prop: 'docNo',
            type: 'input',
            name: this.$t('costAdjustOrderList.search.docNo'),
            clearable: true,
          },
          {
            //单据状态
            prop: 'docStatus',
            type: 'dictSelect',
            name: this.$t('costAdjustOrderList.search.docStatus'),
            apiData: { dictType: 'cost_adjust_order_status' },
            clearable: true,
          },
          //入账状态
          {
            prop: 'accountingStatus',
            name: this.$t('costAdjustOrderList.search.accountingStatus'),
            type: 'dict',
            dictType: 'post_status',
            clearable: true,
          },
          // 调整日期
          {
            prop: 'startGmtCreate',
            name: this.$t('costAdjustOrderList.search.startGmtCreate'),
            type: 'startDaterangePicker',
            clearable: true,
          },
          {
            prop: 'endGmtCreate',
            name: this.$t('costAdjustOrderList.search.endGmtCreate'),
            type: 'endDaterangePicker',
            clearable: true,
          },
          {
            prop: 'voucherNo',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
      this.getCompany();
    },
    methods: {
      getDictValue({ cellValue, column }) {
        return this.$baseRequest.getDictValueByType(column.params.name, cellValue);
      },
      //获取公司信息
      async getCompany() {
        const selectStatus = await this.$axios.get(
          `${DataBaseAPI.LISTDATA_SERECHCOMPANY}/${this.userInfo.tenantCode}`
        );
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data;
        }
      },
      //获取数据
      getData() {
        this.loading.startLoading();
        let query = this.setSearchParams();
        this.$axios.post(API.COST_ADJUST_LIST, filterEmpty(query)).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.tableData = res.data.data.records || [];
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 查询参数整理
      setSearchParams() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
          storageNo:
            query.storageName && query.storageName[0] ? query.storageName[0].storageCode : '',
          storageName:
            query.storageName && query.storageName[0] ? query.storageName[0].storageName : '',
          // supplierName: query.supplierName && query.supplierName[0] ? query.supplierName[0].partnerZhName : '',
          // supplierNo: query.supplierName && query.supplierName[0] ? query.supplierName[0].partnerCode : '',
        });
        return filterEmpty(result);
      },
      // 选择公司
      searchCompanyName(val) {
        this.departmentList = [];
        this.query.departmentCode = '';
        this.getdepartmentList(val.val);
      },
      // 根据公司查询部门
      getdepartmentList(companyCode) {
        this.$axios.post(DataBaseAPI.LIST_DEPARTMENT_API + '/' + companyCode).then((res) => {
          if (res.data.code === 0) {
            this.departmentList = res.data.data;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'edit') {
          if (this.multipleSelection.length !== 1) {
            this.$message({
              showClose: true,
              message: this.$t('costAdjustOrderList.msg.editTips'),
              type: 'error',
            });
          } else {
            const item = this.multipleSelection[0];
            if (['Saved', 'Rejected'].indexOf(item.docStatus) != -1) {
              let path = {
                path: '/wareHouse/costAdjustOrderEdit',
                name: 'costAdjustOrderEdit',
                meta: {
                  keepAlive: true,
                  title: '成本调整单编辑',
                },
                query: { id: item.id, isEdit: 'Y' },
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$message({
                showClose: true,
                message: this.$t('costAdjustOrderList.msg.editTipsError'),
                type: 'error',
              });
            }
          }
        } else if (type == 'delete') {
          this.delete();
        } else if (type == 'export') {
          this.export();
        } else if (type === 'syncVoucher') {
          // 批量过账
          this.batchSyncVoucher(API.BATCH_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type === 'signSyncVoucher') {
          // 批量标记过账
          this.batchSyncVoucher(API.BATCH_SIGN_VOUCHER, {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else if (type === 'doBatchConfirm') {
          // ============ liuhongxia  批量生成凭证 ============
          this.doBatchConfirm('AE_PO_COSTADJUST', {
            idList: this.multipleSelection.map((it) => it.id),
          });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('error.clickError'),
            type: 'error',
          });
        }
      },
      //新增
      add() {
        let path = {
          path: '/wareHouse/costAdjustOrderAdd',
          name: 'costAdjustOrderAdd',
          meta: {
            keepAlive: false,
            title: '成本调整单新增',
          },
          query: { isEdit: 'Y' },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 删除
      delete() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('costAdjustOrderList.msg.deleteTips'),
            type: 'error',
          });
          return false;
        } else {
          let canDelitems = [];
          for (let i = 0; i < this.multipleSelection.length; i++) {
            let temp = this.multipleSelection[i];
            if (temp.docStatus != 'Saved' && temp.docStatus != 'Rejected') {
              this.$message({
                showClose: true,
                message: '只能选择保存或者退回状态的记录！',
                type: 'error',
              });
              return false;
            } else {
              canDelitems.push(temp['id']);
            }
          }
          this.$confirmAction()
            .then(() => {
              this.$axios.post(API.COST_ADJUST_DELETE, canDelitems).then((res) => {
                if (0 == res.data.code) {
                  this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                  this.resetBtnClick();
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        }
      },
      resetBtnClick() {
        this.$refs.siruiTable.clearCheckboxReserve();
        this.getData();
      },
      // 跳转详情页
      dblclickEvent(e) {
        let path = {
          path: '/wareHouse/costAdjustOrderEdit',
          name: 'costAdjustOrderEdit',
          meta: {
            keepAlive: true,
            title: '成本调整单详情',
          },
          query: {
            id: e.row.id,
            isEdit: e.row.docStatus == 'Saved' ? 'Y' : 'N',
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      // 导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        let changeList = this.multipleSelection.concat(selectedList);
        if (changeList.length > 0) {
          let str = '';
          // let ids = changeList.forEach((item) => {
          //   str += 'ids=' + item.id + '&';
          // });
          window.location.href = `${this.baseUrl}${API.COST_ADJUST_EXPORTS}?${str}access_token=${this.userInfo.access_token}`;
        } else {
          let params = this.query;
          delete params.pageNum;
          delete params.pageSize;
          params = XEUtils.serialize(params);
          var reg = new RegExp('%5B%5D', 'g');
          params = params.replace(reg, '');
          window.location.href = `${this.baseUrl}${API.COST_ADJUST_EXPORTS}?${params}&access_token=${this.userInfo.access_token}`;
        }
      },
    },
  };
</script>
